import React, { Component } from 'react';
import { Collapse, Container, Navbar, NavbarBrand, NavbarToggler } from 'reactstrap';
import { Link } from 'react-router-dom';
import { LoginMenu } from './api-authorization/LoginMenu';
import './NavMenu.css';
import {
    CONFIG_BASE_API_URL,
} from '../constans';
import authService from './api-authorization/AuthorizeService';

export class NavMenu extends Component {
  static displayName = NavMenu.name;

  constructor (props) {
    super(props);

    this.toggleNavbar = this.toggleNavbar.bind(this);
    this.state = {
        collapsed: true
    };
  }

  toggleNavbar () {
    this.setState({
      collapsed: !this.state.collapsed
    });
  }

  componentDidMount() {
      this.getRightTrainingStyle();
  }

  render () {
    var logo = "/img/CompanyLogos/" + this.state.icon;
    var icon = "/img/CompanyIcons/" + this.state.icon;

    const colorStyle = {
        borderBottom: 'solid 4px ' + this.state.styleColor
    }

    return (
        <header>
            <Navbar className="ng-white box-shadow shadow-sm" style={colorStyle} light>
          <Container>
                <NavbarBrand tag={Link} to="/">
                    <div>
                        <img className="lw-logo d-none d-sm-block" src={logo} />
                        <img className="lw-icon pl-2 d-block d-sm-none" src={icon} />
                    </div>
                </NavbarBrand> 
            <ul className="navbar-nav flex-grow">
                <LoginMenu>
                </LoginMenu>
            </ul>
          </Container>
        </Navbar>
      </header>
    );
    }


    async getRightTrainingStyle() {
        var logo = "logisticworkx.png";
        let color = "rgb(253, 196, 34)";

        this.setState({
            icon: logo,
            styleColor: color,
        });
    }
}
